import CustomerInfoSection from './CustomerInfoSection';
import InvoiceInfoSection from './InvoiceInfoSection';
import OrderInfoSection from './OrderInfoSection';
import OrderMethodDetailsSection from './OrderMethodDetailsSection';
import PaymentInfoSection from './PaymentInfoSection';
import RememberMeSection from './RememberMeSection';

export default {
  CustomerInfoSection,
  InvoiceInfoSection,
  OrderInfoSection,
  OrderMethodDetailsSection,
  PaymentInfoSection,
  RememberMeSection,
};
